import { CONTENT_TYPE } from '../../constants';

export const REDUX_NAMESPACE = 'CREATIVE_CONTENT';

export const CREATIVE_FIELDS_TYPES = {
  IMAGE: {
    compatibleContentTypes: [CONTENT_TYPE.IMAGE],
  },
  VIDEO: {
    compatibleContentTypes: [CONTENT_TYPE.VIDEO],
  },
  VIDEO_CLIP: {
    compatibleContentTypes: [CONTENT_TYPE.VIDEO],
  },
  AUDIO: {
    compatibleContentTypes: [CONTENT_TYPE.AUDIO],
  },
  TEXT: {
    compatibleContentTypes: [CONTENT_TYPE.TEXT],
  },
  SVG: {
    compatibleContentTypes: [CONTENT_TYPE.SVG],
  },
  INLINE_SVG: {
    compatibleContentTypes: [CONTENT_TYPE.SVG],
  },
};
